<template>
  <div>
    <div class="clearfix"></div>
    <div class="row" v-if="creditId !== -1">
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>Credit transaction details</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <th scope="row">Date & time</th>
                  <td>{{ creditData.created_at }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Type</th>
                  <td>{{ creditData.type }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Credits</th>
                  <td>{{ creditData.credits }}</td>
                  <td></td>
                </tr>
                <tr v-if="creditData.file">
                  <th scope="row">Files</th>
                  <td>
                    <div v-for="file in creditData.file.files">
                      {{ file.name }}
                      <br />
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Comments</th>
                  <td>
                    <div v-for="comment in creditData.comments">
                      {{ comment.date }}: {{ comment.comment }}
                      <br />
                    </div>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div class="clearfix"></div>
            <hr />
            <div class="clearfix"></div>
            <br />
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12" v-if="creditData.customer">
        <div class="card">
          <div class="card-header">
            <h3>Your details</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <th scope="row">Name</th>
                  <td>{{ creditData.customer.first_name }}</td>
                  <td>{{ creditData.customer.last_name }}</td>
                </tr>
                <tr>
                  <th scope="row">Type & Country</th>
                  <td>{{ creditData.customer.type }}</td>
                  <td>{{ creditData.customer.country }}</td>
                </tr>
                <tr>
                  <th scope="row">Credits</th>
                  <td>{{ creditData.customer.credits }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h4>Please load a credit transaction from the overview to show the details here</h4>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    creditId: {
      type: Number
    }
  },
  data: function() {
    return {
      creditData: {
        type: "",
        credits: "",
        customer_id: "",
        file_id: "",
        comments: "",
        customer: {}
      }
    };
  },
  mounted: function() {
    this.countryList = General.getAllCountries();
  },
  methods: {
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    loadCreditDetails(creditId) {
      if (creditId !== -1) {
        Webservice.getCredit(creditId).then(response => {
          this.creditData = response.data;
        });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/credit.vue